import React, { useEffect, useState, useContext } from "react";
import { isMobile, isTablet } from "react-device-detect";
import {
  OptionsRitmoECG,
  OptionsRitmoECGCritical,
  OptionsRitmoECGNormal,
  OptionsRitmoECG_EN,
  OptionsRitmoECGCritical_EN,
  OptionsRitmoECGNormal_EN,
} from "../../helpers/Constants";
import NSMultiSelector from "../NSMultiSelector/NSMultiSelector";
import useTranslation from "../../hooks/useTranslation";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogRitmoPaciente = ({
  fromButtom,
  currentState,
  icon,
  text,
  callbackConfirm,
  callbackCancel,
  status,
  contexto,
  setContexto,
}) => {
  const T = useTranslation();
  const [isOpen, setIsOpen] = useState(status);
  
  // Get current language from context or localStorage
  const currentLanguage = localStorage.getItem('language') || 'ES';
  
  const [DialogItems, setDialogItems] = useState(
    fromButtom
      ? currentState
        ? (currentLanguage === 'EN' ? OptionsRitmoECGNormal_EN : OptionsRitmoECGNormal)
        : (currentLanguage === 'EN' ? OptionsRitmoECGCritical_EN : OptionsRitmoECGCritical)
      : (currentLanguage === 'EN' ? OptionsRitmoECG_EN : OptionsRitmoECG)
  );
  const [ritmoEcg, setRitmoEcg] = useState(contexto.ecgPaciente || []);

  const handlerSetOption = (option = []) => {
    setRitmoEcg(option);
  };
  const updateEcgContext = () => {
    setContexto({
      ...contexto,
      ecgPaciente: ritmoEcg,
    });
  };

  const handlerClose = () => {
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handlerSelect = () => {
    updateEcgContext();
    if (callbackConfirm) {
      callbackConfirm(ritmoEcg, true);
    }
  };

  useEffect(() => {
    setIsOpen(status);
  }, [status]);

  return (
    <>
      <FloatingDialog
        headerText={T(text)}
        headerIcon={icon}
        isOpen={isOpen}
        onClose={handlerClose}
        variant={"bottom"}
      >
        <div className="flex flex-col h-full w-full">
          <div className="w-[100%]  pb-2 max-h-[70vh] flex flex-1 items-start  ">
            <div className="w-full h-full items-start justify-start  overflow-auto">
              <NSMultiSelector
                options={DialogItems}
                contexto={"ecg"}
                onCallBack={handlerSetOption}
                initial={[contexto.ecgPaciente]}
                oneSelection={true}
                className={`grid grid-cols-1 gap-3`}
                criticalItems={[0, 1, 2, 3]}
              />
            </div>
          </div>

          {/* Sticky footer button */}
          <div
            className="w-full pt-4 border-t border-gray-300"
            style={{
              marginBottom: isMobile ? "60px" : "0px",
            }}
          >
            <div className="flex justify-center items-center px-4">
              <SimpleButton disabled={ritmoEcg === contexto.ecgPaciente} text={T("saveAndReturn")} onClick={handlerSelect} />
            </div>
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogRitmoPaciente;
